import Vue from 'vue';

const state = {
  collapseSidebar: false,
  miniCollapseSidebar: false,
  activeTabMenuIndex: '1',
  queryStrings: {},
};

const mutations = {
  set(state, { type, value }) {
    state[type] = value;
  },
  // Vue 2 не следит за новыми ключами в объекте: queryStrings[path] = ...
  // само не обновит экраны. Vue.set говорит Vue: «этот ключ новый, следи за ним».
  setQueryStrings(state, { key, value }) {
    Vue.set(state.queryStrings, key, value);
  },
};

const actions = {
  setCollapseSidebar({ commit }, val: boolean) {
    commit('set', { type: 'collapseSidebar', value: val });
  },
  setMiniCollapseSidebar({ commit }, val: boolean) {
    commit('set', { type: 'miniCollapseSidebar', value: val });
  },
  setActiveTabMenuIndex({ commit }, val: string) {
    commit('set', { type: 'activeTabMenuIndex', value: val });
  },
  saveQueryString: (context, { key, value }: { key: string; value: Record<string, any> }) => {
    context.commit('setQueryStrings', { key, value });
  },
  getQueryStrings: (context, key: string) => {
    return context.getters.queryString(key);
  },
};

const getters = {
  collapseSidebar: (state) => state.collapseSidebar,
  miniCollapseSidebar: (state) => state.miniCollapseSidebar,
  activeTabMenuIndex: (state) => state.activeTabMenuIndex,
  queryString: (state) => (key: string) => state.queryStrings[key] ?? {},
};

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
};
